export default "__VITE_ASSET__BW$aL1Pt__"